import React from 'react';

const card = {
  background: 'rgba(30,45,79,0.5)',
  borderRadius: '16px',
  border: '1px solid rgba(0,194,168,0.1)',
  padding: '24px',
};

export default function SenderTable({ senders }) {
  return (
    <div style={card}>
      <div style={{ marginBottom:'20px' }}>
        <div style={{ fontFamily:'Space Grotesk', fontWeight:600, fontSize:'18px', color:'#F0F4FF' }}>Reporting Organizations</div>
        <div style={{ fontFamily:'Inter', fontSize:'13px', color:'#5B7BA8', marginTop:'4px' }}>
          Mail servers that submitted DMARC reports for your domain
        </div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
        {(senders || []).map((s, i) => {
          const rate = s.total > 0 ? Math.round((s.pass / s.total) * 100) : 0;
          const color = rate >= 90 ? '#00C2A8' : rate >= 70 ? '#F5A623' : '#E8415A';

          return (
            <div key={s.org} style={{
              display:'flex', alignItems:'center', gap:'16px',
              padding:'14px 16px', borderRadius:'10px',
              background:'rgba(15,22,41,0.4)',
              border:'1px solid rgba(0,194,168,0.08)',
            }}>
              <div style={{
                width:'32px', height:'32px', borderRadius:'8px',
                background:'rgba(0,194,168,0.1)', border:'1px solid rgba(0,194,168,0.2)',
                display:'flex', alignItems:'center', justifyContent:'center',
                fontFamily:'Space Grotesk', fontWeight:700, fontSize:'14px', color:'#00C2A8',
                flexShrink:0,
              }}>
                {(i + 1).toString().padStart(2, '0')}
              </div>

              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontFamily:'Space Grotesk', fontSize:'14px', fontWeight:500, color:'#F0F4FF', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                  {s.org}
                </div>
                <div style={{ fontFamily:'JetBrains Mono', fontSize:'11px', color:'#5B7BA8', marginTop:'2px' }}>
                  {s.total.toLocaleString()} emails
                </div>
              </div>

              <div style={{ textAlign:'right', flexShrink:0 }}>
                <div style={{ fontFamily:'Space Grotesk', fontSize:'18px', fontWeight:700, color, lineHeight:1 }}>{rate}%</div>
                <div style={{ fontFamily:'Inter', fontSize:'11px', color:'#5B7BA8', marginTop:'2px' }}>pass rate</div>
              </div>

              <div style={{ width:'6px', height:'40px', borderRadius:'3px', background:`linear-gradient(to bottom, ${color}, ${color}44)`, flexShrink:0 }} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
